module.exports = __webpack_public_path__ + "img/header-phone.ea34e04c.jpg";